<template>
  <div>
    <v-dialog v-model="value" max-width="80%" persistent scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">QR</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex xs6 class="titleSearch">
              <v-text-field
                width="50%"
                @input="filterSearch"
                class="mx-3"
                flat
                label="Buscar"
                prepend-inner-icon="search"
                solo-inverted
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="qrs"
                :custom-filter="customFilter"
                no-data-text="No hay qrs activos para hoy"
                no-results-text="No se encontraron coincidencias"
                :search="filters"
                ref="table"
                :rows-per-page-items="[10, 15, 25]"
                rows-per-page-text="Registros por página"
                expand
              >
                <template v-slot:headers="props">
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </template>
                <template v-slot:pageText="props"
                  >{{ props.pageStart }} - {{ props.pageStop }} de
                  {{ props.itemsLength }}</template
                >
                <template v-slot:items="props">
                  <td>{{ props.item.firstName }}</td>
                  <td>{{ props.item.lastName }}</td>
                  <td>{{ props.item.phone }}</td>
                  <td>
                    <v-chip readonly>
                      <v-avatar>
                        <img
                          :src="
                            'data:image/jpg;base64, ' + props.item.parent.image
                          "
                          alt="alt"
                          v-if="
                            props.item.parent.image != null &&
                            props.item.parent.image != '' &&
                            props.item.parent.image != ' '
                          "
                        />
                        <v-icon v-else>account_circle</v-icon>
                      </v-avatar>
                      {{
                        props.item.parent.firstName +
                        ' ' +
                        props.item.parent.lastName
                      }}
                    </v-chip>
                  </td>
                  <td @click="props.expanded = !props.expanded">
                    <v-btn icon>
                      <v-badge
                        :color="props.item.students.length ? 'green' : 'red'"
                      >
                        <template v-slot:badge>
                          <span>{{ props.item.students.length }}</span>
                        </template>
                        <v-icon class="no-border">
                          {{
                            !props.item.students.length
                              ? 'person_outline'
                              : props.item.students.length == 1
                              ? 'person'
                              : 'group'
                          }}
                        </v-icon>
                      </v-badge>
                    </v-btn>
                  </td>
                </template>
                <template v-slot:expand="props">
                  <Students :students="props.item.students"></Students>
                  <v-divider></v-divider>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="close">Cerrar</v-btn>
          <v-btn flat color="primary" @click="downloadXlsx"> descargar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="toast.loading" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <failed v-model="toast.failed" text="Ups ocurrió un error"></failed>
  </div>
</template>
<script>
import { _downloadFileFromContentDisposition } from '../../utils/genericUtils.js'
import failed from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
import Students from '../Sections/Visor/ThirdQrStudents.vue'

export default {
  props: ['value'],
  components: {
    loading,
    success,
    failed,
    Students,
  },
  data: () => ({
    qrs: [],
    toast: {
      success: false,
      failed: false,
      loading: false,
    },
    headers: [
      { text: 'Nombre', value: 'firstName', align: 'center', sortable: true },
      {
        text: 'Apellidos',
        value: 'lastName',
        sortable: true,
        align: 'center',
      },
      {
        text: 'Teléfono',
        value: 'phone',
        sortable: true,
        align: 'center',
      },
      {
        text: 'Tutor',
        value: 'parent',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Alumnos',
        value: 'students',
        sortable: false,
        align: 'center',
      },
    ],
    filters: {
      search: '',
    },
  }),
  watch: {
    value() {
      if (this.value) {
        this.getQRs()
      }
    },
  },
  methods: {
    async downloadXlsx() {
      this.toast.loading = true

      try {
        const response = await this.$store.dispatch('reports/getThirdQrXlsx')

        _downloadFileFromContentDisposition({ response })
        this.toast.loading = false
        this.toast.success = true
      } catch (error) {
        console.log(error)
        this.toast.loading = false
        this.toast.failed = true
      }
    },
    filterSearch(val) {
      if (!this.toast.loading) {
        this.filters = this.$MultiFilters.updateFilters(this.filters, {
          search: val,
        })
      }
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers)

      cf.registerFilter('search', function (searchWord, items) {
        if (searchWord == null || searchWord.trim() === '') return items
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = searchWord ? searchWord : ''
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return items.filter((item) => {
          return matcher.test(
            [
              item.firstName,
              item.lastName,
              item.firstName + ' ' + item.lastName,
              item.phone,
            ].join()
          )
        }, searchWord)
      })
      return cf.runFilters()
    },
    getQRs() {
      this.toast.loading = true
      this.$store
        .dispatch('tutor/getThirdQr')
        .then((response) => {
          this.toast.loading = false
          this.toast.success = true
          this.qrs = response.data.entity
        })
        .catch((error) => {
          this.toast.loading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
td,
th {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
}
</style>
